const __DEV__ = process.env.NODE_ENV !== 'production'

export default {
  getItem: function (key) {
    let value
    try {
      value = localStorage.getItem(key)
      return value
    } catch (ex) {
      // 开发环境下提示 error
      if (__DEV__) {
        console.error('localStorage.getItem报错，', ex.message)
      }
      return null
    }
    // } finally {
    //   /* eslint no-unsafe-finally: "error" */
    //   return value
    // }
  },
  setItem: function (key, value) {
    try {
      // iOS safari 无痕模式下，直接使用 localStorage.setItem 会报错
      localStorage.setItem(key, value)
    } catch (ex) {
      // 开发环境下提示 error
      if (__DEV__) {
        console.error('localStorage.setItem报错，', ex.message)
      }
    }
  },
  removeItem: function (key) {
    try {
      // iOS safari 无痕模式下，直接使用 localStorage.setItem 会报错
      localStorage.removeItem(key)
    } catch (ex) {
      // 开发环境下提示 error
      if (__DEV__) {
        console.error('localStorage.setItem报错，', ex.message)
      }
    }
  }
}
